module.exports = __webpack_public_path__ + "static/media/F6.5ec1f12b.png";